export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_CODE_SENT = 'fetch_code_sent';
export const FETCH_ERROR = 'fetch_error';
export const FETCH_ALERT = 'fetch_alert';
export const RESET_ALERT = 'reset_alert';

export const SHOULD_LOAD_CONFIGURATIONS = 'should_load_configurations';

export const UPDATE_AUTH_USER = 'update_auth_user';
export const UPDATE_AUTH_LOGOUT = 'update_auth_logout';
export const UPDATE_AUTHORIZATIONS = 'update_authorizations';
export const UPDATE_NAVIGATIONMENU = 'update_navigationmenu';
export const UPDATE_WIDGETS = 'update_widgets';
export const UPDATE_GROUPS = 'update_groups';
export const UPDATE_TEAMSTRUCTURE = 'update_teamstructure';
export const UPDATE_SECTIONS_COLUMNS_WIDGETS = 'update_profile_widgets';
export const UPDATE_LOAD_USER = 'update_load_user';
export const SEND_FORGET_PASSWORD_EMAIL = 'send_forget_password_email';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'signin_google_user_success';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'signin_facebook_user_success';
export const SIGNIN_TWITTER_USER_SUCCESS = 'signin_twitter_user_success';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_SUCCESS';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';

export const SET_NOTIFICATIONS = 'set_notifications';
export const ADD_NOTIFICATION = 'add_notification';
export const UPDATE_NOTIFICATIONS = 'update_notification';

export const MENU_SET_CLASSNAMES = 'menu_set_classnames';
export const MENU_CONTAINER_ADD_CLASSNAME = 'menu_container_add_classname';
export const MENU_CLICK_MOBILE_MENU = 'menu_click_mobile_menu';
export const MENU_CHANGE_DEFAULT_CLASSES = 'menu_change_default_classes';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'menu_change_has_sub_item_status';

export const CHANGE_LOCALE = 'change_locale';
export const UPDATE_VALUES_SYSTEM = 'update_values_system';
export const UPDATE_PROJECTS = 'update_projects';

export const CHANGE_REPORT_FILTERS_USERS = 'change_report_filters_users';
export const CHANGE_REPORT_FILTERS_USERS_STATUS = 'change_report_filters_users_status';
export const CHANGE_REPORT_FILTERS_GROUPS_CATEGORIES = 'change_report_filters_groups_categories';
export const CHANGE_REPORT_FILTERS_RANGE_DATE = 'change_report_filters_range_date';

export const CHANGE_PORTFOLIO_FILTERS_SHOW_PHOTOGRAPH = 'change_portfolio_filters_show_photograph';
export const CHANGE_PORTFOLIO_FILTERS_PARAMETERS = 'change_portfolio_filters_parameters';
export const CHANGE_PROGRESS_FILTERS_PARAMETERS = 'change_progress_filters_parameters';

export const CHANGE_HOME_FILTERS_DATES = 'change_home_filters_dates';
export const CHANGE_MY_NEGOTIATIONS_TYPES_FIELD_ORDER = 'change_my_negotiations_types_field_order';
export const CHANGE_FINALIZED_PLANNING_STATUS = 'change_finalized_planning_status';
export const CHANGE_MONITORS_FILTERS_PARAMETERS = 'change_monitors_filters_parameters';

//LOGIN ENTITY
export const UPDATE_AUTH_ENTITY = 'update_auth_entity';
export const UPDATE_AUTH_ENTITY_LOGOUT = 'update_auth_entity_logout';
